import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { rem } from 'polished';
import { spaces } from '../../../core/styles/theme/default';
import { Hidden } from '../../../helpers';

const StyledToggleText = styled.div(
  ({ titleLineHeight }: any) => css`
    margin-left: ${rem(spaces.epsilon)};
    line-height: ${rem(titleLineHeight)};
  `,
);

const ToggleText = ({
  textCollapsed,
  textExpanded,
  isExpanded,
  titleLineHeight,
}: ToggleTextProps) => {
  const hasText = textCollapsed || textExpanded;

  return hasText ? (
    <Hidden below="medium">
      <StyledToggleText titleLineHeight={titleLineHeight}>
        {isExpanded ? textExpanded : textCollapsed}
      </StyledToggleText>
    </Hidden>
  ) : null;
};

export type ToggleTextProps = {
  textCollapsed?: string;
  textExpanded?: string;
  isExpanded?: boolean;
  titleLineHeight?: string;
};

export default ToggleText;
